export const versionConfig = {
  version: "1.0.26",
  buildDate: "2026-09-07",
  changelog: `
General:
- Track actual received quantity on PO confirmed lines
- Enhance production LOT correction: add items, correct output, propagate costs
- Auto-update recipe names when output stock item description changes
- Add expiring items report with CSV/Excel export
- Add item count to warehouse locations

Amazon:
- Expand daily data collection from 2 to 6 sources (economics, traffic, FBA inventory, inventory planning)
- Add monthly data collection with configurable settling period
- Add advertiser alias as preferred product name in dashboards and reports
- Add data freshness metadata to Daily Dashboard
- Add inventory level and exclude inactive filters to dashboards
- Fix per-unit fee calculation (use Amazon fee quantity instead of units_sold)
- Fix dashboard calculation bugs (ACOS percentage, margin denominator)
- Fix DataKiosk pagination losing collection_type
- Fix unbounded retry storm and concurrent poller execution
- Add retry for Amazon-side report failures (FATAL/CANCELLED)
  `,
  showNotification: true,
  forceReset: false,
  softReset: true
}

// Backward compatibility exports
export const version = versionConfig.version
export const buildDate = versionConfig.buildDate
